import { DashboardComponent } from "~/components/admin/dashboard/dashboard";
import { ActivitySidebar } from "~/components/admin/activity-sidebar";
import PageMeta from "~/components/common/meta";

export function ScreenDashboard() {
  return (
    <>
      <PageMeta title="Dashboard | Art Handler" description="Dashboard" />
      <div className="flex gap-0 -mx-3 -my-2 md:-mx-4 md:-my-3">
        <div className="flex-1 px-3 py-2 md:px-4 md:py-3 min-w-0">
          <DashboardComponent />
        </div>
        <ActivitySidebar />
      </div>
    </>
  );
}
